// ─── Text lifted from an annual report, made readable ────────────────────────
//
// Item 1 is cut from the filing's HTML, so it arrives with the page furniture
// the filing prints on every page (2026-09-26):
//   "Apple Inc. | 2025 Form 10-K | 1"         · the running footer
//   "Apple Inc. | טופס 10-K 2025 | 1"         · the same footer, translated
//   "Item 1. Business" / "סעיף 1. עסקים"     · the heading of the section itself
//   ®, ™, ℠                                  · trademark marks after product names
// None of it is the company's description of its business, so it is removed.
// Nothing else is changed · the words that remain are the filing's.

const FOOTER_RE = /^[^\n|]{0,80}\|[^\n|]*\b(?:10-K|20-F|40-F)\b[^\n|]*\|\s*\d{1,3}\s*$/i;
const PAGE_RE = /^\s*(?:page\s*)?\d{1,3}\s*$/i;
// "Item 1. Business", and the broken forms real filings print: "ITEM 1. B USINESS"
// (Microsoft FY26), "Item 1. Busines s Description" (Berkshire FY25).
const HEADING_RE = /^\s*(?:part\s+i|חלק\s+(?:i|א|1|ראשון)|item\s*1\s*[.:—-]?\s*[a-z\s]{0,30}|סעיף\s*1\s*[.:—-]?\s*[֐-׿\s]{0,20})\s*[.:]?\s*$/i;

export function cleanFilingText(text) {
  if (!text || typeof text !== "string") return "";
  const lines = text.replace(/[ \t]?[®™℠]/g, "").split("\n");
  const kept = lines.filter(l => !FOOTER_RE.test(l.trim()) && !PAGE_RE.test(l));
  // The section heading only where it opens the text (after blank lines).
  while (kept.length && (!kept[0].trim() || HEADING_RE.test(kept[0]))) kept.shift();
  return kept.join("\n").replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}

// Paragraphs · a blank line, or a single line break, ends one.
export function paragraphsOf(text) {
  return cleanFilingText(text).split(/\n\s*\n|\n/).map(p => p.trim()).filter(Boolean);
}

// A sub-heading of the section ("GENERAL", "Company Background"): short, and
// not a sentence. Shown as a heading, and not counted as a paragraph.
export function isSubheading(p) {
  return p.length <= 60 && !/[.?!:;,]$/.test(p);
}

// The opening: paragraphs up to and including the second one that is prose.
export function openingOf(paras, n = 2) {
  let prose = 0;
  for (let i = 0; i < paras.length; i++) {
    if (!isSubheading(paras[i])) prose++;
    if (prose === n) return paras.slice(0, i + 1);
  }
  return paras;
}
